import {Button, DataStatus, FormControl, FormField} from 'platform/components';
import {Heading, HStack, VStack} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {isNilOrEmpty} from 'ramda-adjunct';

import {PutBranchV2ApiArg} from '@dms/api/base';
import {useGetBillingInformationListQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {getBillingInformationOptions} from '@dms/shared';

import {useNavigate} from 'shared/web';

interface BranchBillingInformationFieldProps {
  control: FormControl<PutBranchV2ApiArg>;
}

export function BranchBillingInformationField(props: BranchBillingInformationFieldProps) {
  const navigate = useNavigate();

  const {
    data: billingInformations,
    isLoading: isBillingInformationLoading,
    isError: isBillingInformationError,
  } = useGetBillingInformationListQuery({includeDeactivated: true});

  const selectedBillingInformationId = useWatch({
    control: props.control,
    name: 'billingInformationId',
  });

  const billingInformationOptions = getBillingInformationOptions({
    billingInformations: billingInformations?.billingInformationListItems,
    selectedId: selectedBillingInformationId,
    labelKey: 'billingName',
  });

  const handleCreateNewBillingInformation = () => navigate(settingsRoutes.billingInformationNew);

  return (
    <VStack spacing={5}>
      <HStack justify="space-between" align="center">
        <Heading size={4}>{i18n.t('entity.customer.labels.billingInformation')}</Heading>
        <Button
          title={i18n.t('entity.customer.actions.addNewBillingInformation')}
          leftIcon="content/add_circle"
          variant="link"
          onClick={handleCreateNewBillingInformation}
          data-testid={testIds.settings.branchesEdit('addNewBillingInformation')}
        />
      </HStack>
      <DataStatus
        isLoading={isBillingInformationLoading}
        isError={isBillingInformationError}
        isEmpty={isNilOrEmpty(billingInformationOptions)}
      >
        <FormField
          type="choice"
          control={props.control}
          name="billingInformationId"
          isRequired
          isNotClearable
          options={billingInformationOptions}
          data-testid={testIds.settings.branchesEdit('billingInformationId')}
        />
      </DataStatus>
    </VStack>
  );
}
